export default __webpack_public_path__ + "static/media/all.d96c437e.svg";